import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
let csrfCookieLoaded = false;
//const API_BASE_URL = 'http://localhost:8000/api';
const API_BASE_URL = 'https://api.bscl.gov.bd/api';
// Next we make an 'instance' of it
const instance = axios.create({
// .. where we make our configurations

    baseURL: API_BASE_URL,
    //baseURL: 'https://api.bscl.gov.bd/api',
    withCredentials: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN'

});

const API_ORIGIN = new URL(API_BASE_URL).origin;

const ensureCsrfCookie = async () => {
  if (csrfCookieLoaded) {
    return;
  }

  await axios.get(`${API_ORIGIN}/sanctum/csrf-cookie`, {
    withCredentials: true
  });
  csrfCookieLoaded = true;
};

// Where you would set stuff like your 'Authorization' header, etc ...
//instance.defaults.headers.common['Authorization'] = localStorage.getItem("_authToken");

// Also add/ configure interceptors && all the other cool stuff

instance.interceptors.request.use(async function (config) {
  //const cookies = new Cookies();
    // Do something before request is sent
    const method = (config.method || 'get').toLowerCase();
    if (['post', 'put', 'patch', 'delete'].includes(method)) {
      await ensureCsrfCookie();
    }
    const token = cookies.get('_authToken');
    if (token) {
      config.headers.Authorization = token;
    } else if (config.headers && config.headers.Authorization) {
      delete config.headers.Authorization;
    }
    //this.$Progress.start(); 
    //console.log("intercepted");
    return config;
  }, function (error) {
    
    // Do something with request error
    return Promise.reject(error);
  });
instance.interceptors.response.use(function (response) {
  //const cookies = new Cookies();
  //console.log('request interceptor good');
  return response;
}, function(error) {

  //console.log('request interceptor bad');

  //console.log(error.response.status);
 if (error.response.status === 401) {
  //console.log("kkk");
  //localStorage.clear();
  cookies.remove('_authToken');
            cookies.remove('_role');
            cookies.remove('username');
      window.location.href="/";
 }
 return Promise.reject(error)
});


export default instance;
export { ensureCsrfCookie };
